export default "__VITE_ASSET__d046109e__"